import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Button, Radio } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import _ from 'lodash'

const RadioGroup = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  margin-right: 14px;
  max-width: 700px;
  overflow-x: auto;

  &:hover::-webkit-scrollbar-thumb {
    background: #ccc;
  }

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: transparent;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }

  .radio-button {
    flex: 0 0 auto; /* Prevent buttons from shrinking */
  }

  .ant-radio-button-wrapper {
    line-height: 37px;
    height: 39px;
    font-family: Gilroy;
    padding-inline: 12px;
    color: #7b8794;
  }

  .ant-radio-button-wrapper:hover {
    color: #323f4a;
  }

  .ant-radio-button-wrapper:focus-within {
    box-shadow: none !important;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: #e4e7eb;
    color: #323f4a;
    &::before {
      background-color: transparent;
    }
  }
  .ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {
    border-right-color: #e4e7eb;
  }
`

export const FacilityRadioGroup = ({
  facilities,
  selectedFacilityId,
  callback
}) => {
  const [selectedValue, setSelectedValue] = useState(null)

  const handleChange = (e) => {
    setSelectedValue(e.target.value)
    callback({ facility_ids: [facilities[e.target.value].id] })
  }

  const handleDeselect = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setSelectedValue(null)
    callback({ facility_ids: null })
  }

  useEffect(() => {
    if (selectedFacilityId) {
      setSelectedValue(
        _.findIndex(facilities, (f) => f.id === selectedFacilityId[0])
      )
    } else {
      setSelectedValue(null)
    }
  }, [selectedFacilityId])

  return (
    <RadioGroup>
      <Radio.Group onChange={handleChange} value={selectedValue}>
        {facilities.map((facility, index) => (
          <Radio.Button key={index} value={index} className="radio-button">
            {facility.name}
            {': '}
            {facility.client_count || 0} clients
            {selectedValue === index && (
              <Button
                style={{
                  marginLeft: '4px',
                  width: 16
                }}
                type="text"
                onClick={(e) => handleDeselect(e)}
                icon={
                  <CloseOutlined
                    style={{
                      fontSize: '13px',
                      color: '#52606C'
                    }}
                  />
                }
              />
            )}
          </Radio.Button>
        ))}
      </Radio.Group>
    </RadioGroup>
  )
}
